import { ModuleConfig } from "@core/interfaces";

const config: ModuleConfig = {
  name: "Sellers",
  baseUrl: "",
  routes: [
    {
      path: "/admin/seller",
      page: "SellersPage",
      title: "Sellers Page",
      exact: true,
    },
  ],
  requireAuthenticated: true,
};

export default config;
